import { LEAD_TEXT_FIELDS, type LeadFieldError, type LeadFieldErrors, type LeadSubmissionResult, type SubmitLead } from "../../contracts";

// The seam between the connect form and lead intake (DSH-015 phase 2): a POST
// to the leads route, which checks the request again, stores it and notifies
// Nick on Telegram. "ok" means the server stored the lead.

const ROUTE = "/api/leads";
const FIELD_ERRORS: readonly LeadFieldError[] = ["company_required", "name_required", "contact_invalid", "too_long"];

function fieldErrors(value: unknown): LeadFieldErrors {
  const errors: LeadFieldErrors = {};
  if (typeof value !== "object" || value === null) return errors;
  for (const field of LEAD_TEXT_FIELDS) {
    const code = (value as Record<string, unknown>)[field];
    if (typeof code === "string" && (FIELD_ERRORS as readonly string[]).includes(code)) errors[field] = code as LeadFieldError;
  }
  return errors;
}

export const submitLead: SubmitLead = async (submission): Promise<LeadSubmissionResult> => {
  try {
    const response = await fetch(ROUTE, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      cache: "no-store",
      body: JSON.stringify(submission),
    });
    const body = (await response.json().catch(() => null)) as { ok?: unknown; error?: unknown; fields?: unknown; reference?: unknown } | null;
    if (response.status === 201 && body?.ok === true) return { ok: true };
    if (response.status === 429) return { ok: false, code: "rate_limited" };
    if (response.status === 400 && body?.error === "invalid") return { ok: false, code: "invalid", fields: fieldErrors(body.fields) };
    const reference = typeof body?.reference === "string" && /^[A-Za-z0-9_-]{1,16}$/.test(body.reference) ? body.reference : undefined;
    return { ok: false, code: "unavailable", reference };
  } catch {
    return { ok: false, code: "unavailable" };
  }
};
